import { FC } from 'react';

import styles from './ErrorCard.module.css';

export interface ErrorCardProps {
  errorMessage: string;
}

export const ErrorCard: FC<ErrorCardProps> = ({ errorMessage }) => (
  <span className={styles.errorCard} data-testid="error-card">
    {errorMessage}
  </span>
);
